import React from "react";

export default () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M224 960a160 160 0 1 0 0-320 160 160 0 0 0 0 320z m576-576a160 160 0 1 0 0-320 160 160 0 0 0 0 320z m0 576a160 160 0 1 1 0-320 160 160 0 0 1 0 320zM1024 224a224 224 0 1 1-448 0 224 224 0 0 1 448 0z m-576 576a224 224 0 1 1-448 0 224 224 0 0 1 448 0z m352 224a224 224 0 1 0 0-448 224 224 0 0 0 0 448z m-576-704a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0 128a224 224 0 1 0 0-448 224 224 0 0 0 0 448z"
        fill="#2c2c2c"
      />
    </svg>
  );
};
